import ReportGridSquareComponent from './report-grid-square-component';

/***
 * A single square in a report grid. A square will have one of several colors and font awesome icons and can have
 * a link for an available report when the square is in its "complete" state.
 */
const reportGridSquare = angular
    .module('FacilityData.Common.ReportGridSquare', [])
    .component('reportGridSquare', ReportGridSquareComponent)
    .name;

export default reportGridSquare;


// WEBPACK FOOTER //
// ./app/common/report-grid-square/report-grid-square.js